var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetinBoyutuStandart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MetinBoyutu-Standart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-773.000000, -2579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MetinBoyutu-Standart",
    transform: "translate(773.000000, 2579.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4609375,17.3359375 L7.85742188,13.3710938 L13.3164062,13.3710938 L14.7421875,17.3359375 L17.2226562,17.3359375 L11.8808594,3 L9.34179688,3 L4,17.3359375 L6.4609375,17.3359375 Z M12.7011719,11.359375 L8.54101562,11.359375 L9.83007812,7.63867188 C10.1686198,6.68815104 10.4257812,5.8125 10.6015625,5.01171875 C10.6666667,5.27213542 10.7854818,5.68229167 10.9580078,6.2421875 C11.1305339,6.80208333 11.265625,7.21223958 11.3632812,7.47265625 L11.3632812,7.47265625 L12.7011719,11.359375 Z",
    id: "A",
    fill: "#464646",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetinBoyutuStandart);
export default __webpack_public_path__ + "static/media/MetinBoyutu-Standart.8a31b279361c67f6f936435bf2eb1535.svg";
export { ForwardRef as ReactComponent };